import _toString from 'lodash/toString';

export function calculateStepString(decimalPrecision) {
  return _toString(1 / 10 ** decimalPrecision);
}
